export const GLOBAL_STORE_LABELS = 'global.store';
export const lblStoreLocatorWelcomeTxt = 'lbl_storelocator_welcomeTxt';

const GlobalStoreLabels = {
  global: {
    store: {
      [lblStoreLocatorWelcomeTxt]: 'Welcome!',
    },
  },
};

export default GlobalStoreLabels;
